export default __webpack_public_path__ + "static/media/home-decor-img-07.767139c6.jpg";